import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _dec,
  _class,
  localeSettings,
  localeConfiguration,
  _excluded = ["value"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import "core-js/modules/es.regexp.exec.js";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import { getConfigValue } from "@jutro/config";
import { log } from "@jutro/logger";
import { logDeprecationMessage } from "@jutro/platform";
import { service, ServiceManager } from "@jutro/services/internal";
import { getBrowserLanguage, getCountryCodeFromLocale } from "./locale";
import LocaleSettingsInterface from "./LocaleSettingsInterface";
export var LOCALE_SERVICE_ID = "locale";
export var LOCALE_URL_PARAM = "selectedLocale";
export var LANGUAGE_URL_PARAM = "selectedLanguage";
var getLocaleSettings = function () {
    return localeSettings || (localeSettings = ServiceManager.getServiceByContract(LocaleSettingsInterface)) && logDeprecationMessage("Fetching locale settings from service", "config.json file to store locale settings"), localeSettings;
  },
  getLocaleConfig = function () {
    return localeConfiguration || (localeConfiguration = getConfigValue("localeSettings")), localeConfiguration;
  },
  getUrlParam = function (paramName) {
    return new _URLSearchParams(window.location.search).get(paramName);
  },
  _getStoredLocale = function () {
    var skipLocalStoragePersistence = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
      skipURLPersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    if (!skipURLPersistence) {
      var urlValue = getUrlParam(LOCALE_URL_PARAM);
      if (urlValue) return urlValue;
    }
    if (!skipLocalStoragePersistence) {
      var localStorageValue = localStorage.getItem("selectedLocale");
      if (localStorageValue) return localStorageValue;
    }
    return null;
  },
  _getStoredLanguage = function () {
    var skipLocalStoragePersistence = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
      skipURLPersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    if (!skipURLPersistence) {
      var urlValue = getUrlParam(LANGUAGE_URL_PARAM);
      if (urlValue) return urlValue;
    }
    if (!skipLocalStoragePersistence) {
      var localStorageValue = localStorage.getItem("selectedLanguage");
      if (localStorageValue) return localStorageValue;
    }
    return null;
  },
  saveLocale = function (locale) {
    localStorage.setItem("selectedLocale", locale);
  },
  saveLanguage = function (language) {
    localStorage.setItem("selectedLanguage", language);
  },
  findAvailableLocale = function () {
    var browserLanguage = getBrowserLanguage(),
      availableLocales = _getAvailableLocales();
    if (availableLocales && availableLocales.length && _includesInstanceProperty(availableLocales).call(availableLocales, browserLanguage)) return browserLanguage;
    var preferredLocale = getPreferredLocale();
    return preferredLocale || browserLanguage;
  },
  findAvailableLanguage = function () {
    var browserLanguage = getBrowserLanguage(),
      availableLanguages = _getAvailableLanguages();
    if (availableLanguages && availableLanguages.length && _includesInstanceProperty(availableLanguages).call(availableLanguages, browserLanguage)) return browserLanguage;
    var preferredLanguage = getPreferredLanguage();
    return preferredLanguage || browserLanguage;
  },
  _getAvailableLanguages = function () {
    var settings = getLocaleSettings(),
      localeConfig = getLocaleConfig();
    return settings ? settings.getAvailableLanguages() : localeConfig && localeConfig.availableLanguages ? localeConfig.availableLanguages : [];
  },
  _getAvailableLocales = function () {
    var settings = getLocaleSettings(),
      localeConfig = getLocaleConfig();
    return settings ? settings.getAvailableLocales() : localeConfig && localeConfig.availableLocales ? localeConfig.availableLocales : (log.warning("No locale configuration or settings provided."), []);
  },
  getPreferredLanguage = function () {
    var settings = getLocaleSettings(),
      localeConfig = getLocaleConfig();
    return settings ? settings.getPreferredLanguage() : localeConfig && localeConfig.preferredLanguage ? localeConfig.preferredLanguage : (log.warning("No locale configuration or settings provided."), null);
  },
  getPreferredLocale = function () {
    var settings = getLocaleSettings(),
      localeConfig = getLocaleConfig();
    return settings ? settings.getPreferredLocale() : localeConfig && localeConfig.preferredLocale ? localeConfig.preferredLocale : (log.warning("No locale configuration or settings provided."), null);
  };
export var getDefaultCountryCode = function () {
  logDeprecationMessage("getDefaultCountryCode", "getDefaultCountry", "It relies on LocaleService which is deprecated.");
  var settings = getLocaleSettings(),
    localeConfig = getLocaleConfig();
  return settings ? settings.getDefaultCountryCode() : localeConfig && localeConfig.defaultCountryCode ? localeConfig.defaultCountryCode : (log.warning("No locale configuration or settings provided."), null);
};
export var getDefaultCurrency = function () {
  var localeConfig = getLocaleConfig();
  return localeConfig && localeConfig.defaultCurrency ? localeConfig.defaultCurrency : (log.warning("No locale configuration provided."), "USD");
};
export var getDefaultTimeZone = function () {
  var localeConfig = getLocaleConfig(),
    fallbackTimeZoneCode = getTimeZoneFallback();
  return localeConfig && localeConfig.defaultTimeZone ? localeConfig.defaultTimeZone : fallbackTimeZoneCode;
};
export var getTimeZoneFallback = function () {
  var _Intl$DateTimeFormat$, _Intl$DateTimeFormat;
  return (null === (_Intl$DateTimeFormat$ = (_Intl$DateTimeFormat = Intl.DateTimeFormat()).resolvedOptions) || void 0 === _Intl$DateTimeFormat$ ? void 0 : _Intl$DateTimeFormat$.call(_Intl$DateTimeFormat).timeZone) || "UTC";
};
export var LocaleService = (_dec = service(LOCALE_SERVICE_ID), _dec(_class = function () {
  function LocaleService() {
    _classCallCheck(this, LocaleService), _defineProperty(this, "JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE", null), _defineProperty(this, "localeChangeListeners", void 0), _defineProperty(this, "languageChangeListeners", void 0), _defineProperty(this, "currentLocale", void 0), _defineProperty(this, "currentLanguage", void 0), _defineProperty(this, "storedLanguageWasRead", !1), _defineProperty(this, "storedLocaleWasRead", !1), this.localeChangeListeners = [], this.languageChangeListeners = [];
  }
  return _createClass(LocaleService, [{
    key: "settings",
    get: function () {
      return getLocaleSettings();
    }
  }, {
    key: "locale",
    get: function () {
      return this.getCurrentLocale();
    },
    set: function (newLocale) {
      this.setCurrentLocale(newLocale);
    }
  }, {
    key: "language",
    get: function () {
      return this.getCurrentLanguage();
    },
    set: function (newLanguage) {
      this.setCurrentLanguage(newLanguage);
    }
  }, {
    key: "getAvailableLocales",
    value: function () {
      return _getAvailableLocales();
    }
  }, {
    key: "getAvailableLanguages",
    value: function () {
      return _getAvailableLanguages();
    }
  }, {
    key: "getCountry",
    value: function () {
      return this.getCurrentCountry() || getDefaultCountryCode();
    }
  }, {
    key: "getCurrentCountry",
    value: function () {
      return getCountryCodeFromLocale(this.locale);
    }
  }, {
    key: "getCurrentLocale",
    value: function () {
      var skipLocalStoragePersistence = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        skipURLPersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return this.initFromStoredLocale(skipLocalStoragePersistence, skipURLPersistence), this.currentLocale || this.setCurrentLocale(findAvailableLocale(), skipLocalStoragePersistence), this.currentLocale;
    }
  }, {
    key: "getCurrentLanguage",
    value: function () {
      var skipLocalStoragePersistence = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        skipURLPersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return this.initFromStoredLanguage(skipLocalStoragePersistence, skipURLPersistence), this.currentLanguage || this.setCurrentLanguage(findAvailableLanguage(), skipLocalStoragePersistence), this.currentLanguage;
    }
  }, {
    key: "initFromStoredLocale",
    value: function (skipLocalStoragePersistence, skipURLPersistence) {
      if (!this.storedLocaleWasRead) {
        var storedLocale = _getStoredLocale(skipLocalStoragePersistence, skipURLPersistence);
        storedLocale && (this.currentLocale = storedLocale), this.storedLocaleWasRead = !0;
      }
    }
  }, {
    key: "initFromStoredLanguage",
    value: function (skipLocalStoragePersistence, skipURLPersistence) {
      if (!this.storedLanguageWasRead) {
        var storedLanguage = _getStoredLanguage(skipLocalStoragePersistence, skipURLPersistence);
        storedLanguage && (this.currentLanguage = storedLanguage), this.storedLanguageWasRead = !0;
      }
    }
  }, {
    key: "getStoredLocale",
    value: function () {
      return _getStoredLocale();
    }
  }, {
    key: "getStoredLanguage",
    value: function () {
      return _getStoredLanguage();
    }
  }, {
    key: "setCurrentLocale",
    value: function (newLocale) {
      var skipLocalStoragePersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      this.currentLocale = newLocale, skipLocalStoragePersistence || saveLocale(newLocale), this.localeChangeListeners.forEach(function (listener) {
        return listener(newLocale);
      });
    }
  }, {
    key: "setCurrentLanguage",
    value: function (newLanguage) {
      var skipLocalStoragePersistence = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      this.currentLanguage = newLanguage, skipLocalStoragePersistence || saveLanguage(newLanguage), this.languageChangeListeners.forEach(function (listener) {
        return listener(newLanguage);
      });
    }
  }, {
    key: "onLocaleChange",
    value: function (callback) {
      this.localeChangeListeners.push(callback);
    }
  }, {
    key: "onLanguageChange",
    value: function (callback) {
      this.languageChangeListeners.push(callback);
    }
  }, {
    key: "getConfiguredPhoneRegion",
    value: function () {
      return getDefaultCountryCode();
    }
  }]), LocaleService;
}()) || _class);
function logLocaleServiceDeprecationMessage() {
  logDeprecationMessage("LocaleService", "globalization store", void 0, "10.0.0");
}
_Object$entries(_Object$getOwnPropertyDescriptors(LocaleService.prototype)).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    propName = _ref2[0],
    _ref2$ = _ref2[1],
    _value = _ref2$.value,
    propDesc = _objectWithoutProperties(_ref2$, _excluded);
  "function" == typeof _value && _Object$defineProperty(LocaleService.prototype, propName, _objectSpread(_objectSpread({}, propDesc), {}, {
    value: function () {
      var _context;
      logLocaleServiceDeprecationMessage();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
      return _value.call.apply(_value, _concatInstanceProperty(_context = [this]).call(_context, args));
    }
  }));
});
export default ServiceManager.getService(LOCALE_SERVICE_ID);